import React, { Fragment } from 'react'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import GlobalStyle from '../../constants/globalStyle'
import Navbar from '../Navbar'
import Footer from '../Footer'

const SkipLink = styled.a`
  padding: 6px 15px;
  position: absolute;
  top: -40px;
  left: 0px;
  color: white;
  border-right: 1px solid white;
  border-bottom: 1px solid white;
  background: #424449;
  z-index: 9999;

  &:focus {
    position: absolute;
    left: 0px;
    top: 0px;
    outline-color: transparent;
  }
`

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={() => (
      <Fragment>
        <GlobalStyle />
        <SkipLink href="#maincontent">Skip to main content</SkipLink>
        <Navbar />
        <main id="maincontent">{children}</main>
        <Footer />
      </Fragment>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout
